<template>
    <div :class="`status-dialogs-order-card ${showMore ? 'status-dialogs-order-card__show-more' : ''}`">
        <div class="status-dialogs-order-card__content__inline-space-between">
            <div class="status-dialogs-order-card__content__inline">
                <div class="status-dialogs-order-card__icon">
                    <img :src="`static/statuses-new/${getStatusImg(order)}.png`" />
                </div>
                <div class="status-dialogs-order-card__content">
                    <div class="status-dialogs-order-card__content__entity">
                        {{ getStatus(order) }}
                    </div>
                    <div class="status-dialogs-order-card__content__slogan">
                        {{ getEntity(order) }}
                    </div>
                </div>
            </div>
            <div>
                <div class="status-dialogs-order-card__content__price">
                    {{ priceFormat(orderPrice) }}&nbsp;Р
                </div>
            </div>
        </div>
        <div class="status-dialogs-order-card__content__inline status-dialogs-order-card__steps">
            <div v-for="i in maxStatusStep" :key="i">
                <div :class="`status-dialogs-order-card__steps__item ${i <= statusStep ? 'status-dialogs-order-card__steps__item__active' : ''}`"></div>
            </div>
        </div>

        <div v-if="order.status === ORDER_STATUS.MEETING_POINT">
            <div class="status-dialogs-order-card__content__inline">
                <div class="status-dialogs-order-card__icon">
                    <!-- <img :src="paidWaitingFree ? `static/statuses-new/waiting-free.png` : `static/statuses-new/waiting-paid.png`" /> -->
                </div>
                <div class="status-dialogs-order-card__content__inline-space-between" style="align-items: center;">
                    <div class="status-dialogs-order-card__content__slogan">
                        {{ paidWaitingFree ? 'До конца бесплатного ожидания' : 'Время платного ожидания' }}
                    </div>
                    <div class="status-dialogs-order-card__content__timer">
                        {{ paidWaitingTimer }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import moment from '../../plugins/moment';
    import { STATUS_DIALOGS_TYPES, DELIVERY_TYPE, ORDER_STATUS, ORDER_PAYMENT_STATUS, PAYMENT_TYPE } from '@/js/utils/vars';
    import { priceFormat } from '@/js/utils/service-helpers.js';
    import { repeatOrder } from '@/js/utils/orders';

    import { sendAppMetricaEvent, checkEnabledService } from '@/js/utils/service-helpers';

    export default {
        name: 'StatusDialogOrderCard',

        props: {
            order: {
                type: Object,
                default: {},
            },
            showMore: {
                type: Boolean,
                default: false
            },
        },
        
        data: () => ({
            ORDER_STATUS,
            priceFormat,
            shown: false,
            intervalId: null,
            freeSeconds: 195 * 60,
            paidWaitingFree: true,
            paidWaitingTimer: '',
            maxStatusStep: 4,
            statusStep: 0,
        }),

        computed: {
            createdAt() {
                return moment(this.order.created_at).format('DD MMMM YYYY')
            },
            orderPrice() {
                return +this.order.price ? +this.order.price + +this.order.delivery_price + +this.order.waiting_price + (+this.order.service_fee || 0) : 0;
            },
            rating() {
                return +this.order.review?.rating || 0;
            },
            withoutDelivery() {
                return (this.order.delivery_type === DELIVERY_TYPE.WITHOUT || this.order.delivery_type === DELIVERY_TYPE.COLLECT);
            },
        },

        created() {
            this.startTimer();
        },
        destroyed() {
            clearInterval(this.intervalId);
        },
        mounted() {
            if(this.withoutDelivery) {
                this.maxStatusStep = 3;
            }
        },

        methods: {
            startTimer() {
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                }
                this.paidWaitingFetch();
                this.intervalId = setInterval(() => {
                    this.paidWaitingFetch();
                }, 1000);
            },
            paidWaitingFetch() {
                if (this.order.status === ORDER_STATUS.MEETING_POINT) {
                    if (this.order.status === ORDER_STATUS.MEETING_POINT) {
                        const currentTime = moment().unix();
                        const updatedTime = moment(this.order.meeting_point_at).unix();
                        this.paidWaitingFree = currentTime - updatedTime < this.order.waiting_free_seconds;
                        let ms = (currentTime - updatedTime) - this.order.waiting_free_seconds;
                        if (this.paidWaitingFree) {
                            ms = this.order.waiting_free_seconds - (currentTime - updatedTime);
                        }
                        if(Math.floor(ms / 60) > 10) {
                            this.paidWaitingTimer = `${Math.floor(ms / 60)}:${('0' + ms % 60).slice(-2)}`;
                        } else {
                            this.paidWaitingTimer = `${('0' + Math.floor(ms / 60)).slice(-2)}:${('0' + ms % 60).slice(-2)}`;
                        }
                    }
                }
            },

            isPostpayment(order) {
                return order?.partner?.payment === PAYMENT_TYPE.POST_PAYMENT;
            },
            processingPayment(order) {
                return order && order.payments ? order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.PROCESSING) : false
            },
            faildPayment(order) {
                return order && order.payments ? order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.FAIL || item.status === ORDER_PAYMENT_STATUS.CANCELED) : false
            },
            paided(order) {
                return order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.SUCCESS) ? true : false;
            },
            paymentStatusTitle(order) {
                if(this.isPostpayment(order)) {
                    return '';
                }
                return order.payments.find(item => item.status === ORDER_PAYMENT_STATUS.SUCCESS) ? 'оплачен' : 'не оплачен';
            },
            getStatusImg(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                    if(!this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'payment_in_progress';
                        }
                        return 'not_paid';
                    }
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                    this.statusStep = 1;
                    return 'submitted';
                case ORDER_STATUS.PREPARED:
                    this.statusStep = 0;
                    if(this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'payment_in_progress';
                        }
                        return 'not_paid';
                    }
                case ORDER_STATUS.PAID:
                case ORDER_STATUS.AWAITING:
                    this.statusStep = 2;
                    return 'awating';
                case ORDER_STATUS.AWAITING_READY:
                case ORDER_STATUS.DELIVERY:
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    if(!this.withoutDelivery) {
                        this.statusStep = 3;
                        return 'delivery';
                    }
                case ORDER_STATUS.MEETING_POINT:
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    this.statusStep = 4;
                    return 'done';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    this.statusStep = 0;
                    return 'canceled';
                default:
                    return '';
                }
            },

            getStatus(order) {
                switch (order.status) {
                case ORDER_STATUS.SUBMITTED:
                    if(!this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'Платеж в обработке';
                        }
                        if(this.faildPayment(order)) {
                            return 'Оплата не прошла';
                        }
                        return 'Заказ не оплачен';
                    }
                case ORDER_STATUS.IN_WORK:
                case ORDER_STATUS.ACCEPTED:
                    return 'Мы получили ваш заказ';
                case ORDER_STATUS.PREPARED:
                    if(this.isPostpayment(order)) {
                        if(this.processingPayment(order)) {
                            return 'Платеж в обработке';
                        }
                        if(this.faildPayment(order)) {
                            return 'Оплата не прошла';
                        }
                        return 'Заказ требует оплаты';
                    }
                case ORDER_STATUS.PAID:
                    if(this.isPostpayment(order)) {
                        return 'Заказ оплачен';
                    }
                case ORDER_STATUS.AWAITING:
                    return 'Заказ в работе';
                case ORDER_STATUS.AWAITING_READY:
                case ORDER_STATUS.DELIVERY:
                    if(!this.withoutDelivery) {
                        return 'Заказ у курьера';
                    }
                case ORDER_STATUS.DELIVERY_CONCIERGE:
                    if(!this.withoutDelivery) {
                        return 'Заказ у консьержа';
                    }
                case ORDER_STATUS.MEETING_POINT:
                    if(!this.withoutDelivery) {
                        return 'Заказ доставлен';
                    }
                case ORDER_STATUS.DONE:
                case ORDER_STATUS.PAYMENT_CORRECTION:
                case ORDER_STATUS.DELIVERED_DOOR:
                    return 'Заказ выполнен';
                case ORDER_STATUS.CANCELED:
                case ORDER_STATUS.DECLINED:
                    return 'Заказ отменен';
                default:
                    return '';
                }
            },
            getEntity(order) {
                return order.rd?.items[0]?.restaurant.title
                    || order.gd?.items[0]?.grocer.title
                    || order.ed?.items[0]?.entity.title;
            },
            openOrder(order) {
                const orderId = order.id;
                if (!order?.gd?.items[0]?.grocer?.status_postpay && order.status === ORDER_STATUS.SUBMITTED || order.status === ORDER_STATUS.CANCELED) {
                    return;
                }
                this.$f7.views[0].router.navigate({
                    name: 'orders-detail',
                    params: {
                        orderId
                    }
                });
            },
        }
    };
</script>

<style lang="scss">
.status-dialogs-order-card {
    line-height: 100%;
    letter-spacing: 0%;

    &__show-more {
        padding-right: 20px;
    }

    &__separate {
        height: 1px;
        background-color: #E8E8E8;
        margin: 10px 0;
    }

    &__steps {
        margin: 8px 0 0 46px;

        &__item {
            margin-right: 6px;
            width: 40px;
            height: 4px;
            border-radius: 4px;
            background: #E8E8E8;

            &__active {
                background: #1F3A60;
            }
        }
    }

    &__icon {
        min-width: 46px;
        padding-right: 16px;
        img {
            width: 30px;
            max-width: 30px;
        }
    }
    &__content {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        color: #232321;

        &__inline {
            display: flex;
            align-items: flex-star;
        }
        &__inline-space-between {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
        }
        &__date {
            margin-bottom: 8px;
            font-weight: 400;
            font-size: 12px;
        }
        &__payment {
            font-weight: 400;
            font-size: 12px;
            color: #F54842;

            &__paided {
                color: #CC9C6E;
            }
        }
        &__id {
            margin-bottom: 6px;
            font-weight: 400;
            font-size: 12px;
            text-align: right;
        }
        &__price {
            font-weight: 600;
            font-size: 12px;
        }
        &__entity {
            margin-bottom: 6px;
            font-weight: 500;
            font-size: 14px;
        }
        &__slogan {
            font-weight: 400;
            font-size: 12px;
        }
        &__timer {
            font-weight: 600;
            font-size: 12px;
            line-height: 100%;
            text-align: center;
            padding: 6px 10px;
            border-radius: 90px;
            background: #F4F4F4;

        }
    }
    &__button {
        &__again {
            width: auto;
            padding: 9px 12px 9px 28px;
            font-weight: 500;
            font-size: 12px;
            line-height: 120%;
            letter-spacing: 0%;
            color: #1F3A60;
            border-radius: 8px;
            border: 1px solid #1F3A60;
            background: url('../../static/repeat-blue.svg') left 8px center no-repeat;
        }
    }


    &__rate {
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;

        &__title {
            font-weight: 400;
            font-size: 13px;
            line-height: 100%;
            text-align: center;
            color: #7D7D7D;
            margin-top: 24px;
            margin-bottom: 20px;
        }

        button {
            width: 16px;
            margin-left: 4px;
        }
    }
}
</style>
